import * as React from "react";
import { useTranslation } from "react-i18next";
import { useMetric } from "hooks/useMetrics";
import { Spinner } from "components/common";
import { formatCount, getValueFromMetric, prefixMetric } from "components/inputs/helpers/InputThroughputUtils";
const METRIC_NAME = "incomingMessages";
const ThroughputCell = ({ input }) => {
  const { t } = useTranslation("inputs");
  const metricName = prefixMetric(input, METRIC_NAME);
  const { data: metrics, isLoading } = useMetric(metricName);
  if (isLoading || Object.keys(metrics).length === 0) {
    return /* @__PURE__ */ React.createElement(Spinner, { size: "xs" });
  }
  const incomingMessages = Object.keys(metrics).reduce((previous, nodeId) => {
    var _a, _b;
    if (!((_a = metrics == null ? void 0 : metrics[nodeId]) == null ? void 0 : _a[metricName])) {
      return previous;
    }
    const value = getValueFromMetric((_b = metrics == null ? void 0 : metrics[nodeId]) == null ? void 0 : _b[metricName]);
    if (value !== void 0) {
      return isNaN(previous) ? value : previous + value;
    }
    return previous;
  }, NaN) || 0;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, t("overview.cells.throughput", { value: !isNaN(incomingMessages) ? formatCount(incomingMessages) : 0 }));
};
export default ThroughputCell;
